import api from '@/api';

export default {
  list: filter =>
    new Promise((resolve, reject) => {
      let endpoint = '/system/statuses';
      if (filter !== 'all') {
        endpoint = '/system/statuses/favourites';
      }

      api()
        .get(endpoint)
        .then(response => resolve(response.data.data.status))
        .catch(error => reject(error.response));
    }),

  create: () =>
    new Promise((resolve, reject) => {
      //
    }),

  read: () =>
    new Promise((resolve, reject) => {
      //
    }),

  update: () =>
    new Promise((resolve, reject) => {
      //
    }),

  delete: systemId =>
    new Promise((resolve, reject) => {
      api()
        .delete(`/system/status/${systemId}`)
        .then(response => resolve(response.data.data.status[0]))
        .catch(error => reject(error.response));
    }),

  // -------------------------------------------------------

  favourite: systemId =>
    new Promise((resolve, reject) => {
      api()
        .put(`/system/status/${systemId}/favourite`)
        .then(response => resolve(response.data.data.status[0]))
        .catch(error => reject(error.response));
    }),

  unfavourite: systemId =>
    new Promise((resolve, reject) => {
      api()
        .put(`/system/status/${systemId}/unfavourite`)
        .then(response => resolve(response.data.data.status[0]))
        .catch(error => reject(error.response));
    }),
};
